var _defs, _ellipse, _g, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSadFilled(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 481.82 481.59",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}.cls-2{fill:#f18a21;}"))), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-2",
    cx: 240.91,
    cy: 240.8,
    rx: 240.91,
    ry: 240.8
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-1",
    cx: 168.29,
    cy: 190.75,
    rx: 24.59,
    ry: 24.58
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-1",
    cx: 313.53,
    cy: 190.75,
    rx: 24.59,
    ry: 24.58
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M321.44,330.8c-1.7,0-3.42-.28-5.11-.88-27.16-9.58-53.77-14.51-79.09-14.66-.38,0-.76,0-1.13,0-23.78,0-48.3,4.34-71,12.57-7.98,2.89-16.79-1.23-19.69-9.21-2.89-7.98,1.23-16.79,9.21-19.69,26.44-9.59,55.06-14.56,82.79-14.41,28.75,.17,58.74,5.69,89.13,16.41,8,2.82,12.2,11.6,9.38,19.6-2.23,6.31-8.16,10.26-14.49,10.26Z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSadFilled);
export default __webpack_public_path__ + "static/media/sad-filled.c5c6b4f19de8f490414f6aa43ab137fb.svg";
export { ForwardRef as ReactComponent };